import {
  Box,
  useMediaQuery,
  Select,
  Typography,
  MenuItem,
  Alert,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

import CustomCuratorRadioGroup from "./CustomCuratorRadioGroup";
import CustomSelect from "../../Upload/CustomSelect";
import {
  getDropDownOptionValues,
  getCountryList,
} from "../../../utils/function";
import useThemeRender from "../../../theme/useThemeRender";
import useDebounce from "../../../hooks/useDebounce";
import { getAPI } from "../../../API/ApiService";
import { BASE_URL } from "../../../constant/apiUrl";
import { useParams } from "react-router-dom";
import { TextInput } from "pepsico-ds";
import useDuplicateTitleCheck from "../../../hooks/useDuplicateCheck";
import { CURATOR_PAGE_API_CONSTANT } from "../../../constant/constant";

const ContentDetails = ({
  errors,
  register,
  setContentDetailsSectionData,
  contentDetailsSectionData,
  lookUpOptions,
  countryData,
  secotrByCountrylist,
  setCountryData,
  subjectExpert,
  pageName,
}) => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const borderColorLayer1 = useThemeRender("borderColorLayer1");
  const [selectedSectorData, setSelectedSectorData] = useState([]);
  const [selectedCountryData, setSelectedCountryData] = useState([]);
  const [selectedSubjectData, setSelectedSubjectData] = useState([]);
  const [selectedSpecialProjectData, setSelectedSpecialProjectData] = useState(
    []
  );
  const [selectedVarities, setSelectedVarities] = useState([]);
  const [selecteSubjectMatterExpert, setSelecteSubjectMatterExpert] = useState(
    []
  );

  const { id } = useParams();

  const debouncedTitle = useDebounce(
    contentDetailsSectionData.contentTitle,
    500
  );
  useEffect(() => {
    const selectedData = lookUpOptions?.sectorFilter?.filter((item) =>
      contentDetailsSectionData?.sectors?.includes(item?.id)
    );
    setSelectedSectorData(selectedData);
  }, [contentDetailsSectionData?.sectors, lookUpOptions?.sectorFilter]);
  useEffect(() => {
    const selectedData = lookUpOptions?.specialProjects?.filter((item) =>
      contentDetailsSectionData?.specialProjects?.includes(item?.id)
    );
    setSelectedSpecialProjectData(selectedData);
  }, [
    contentDetailsSectionData?.specialProjects,
    lookUpOptions?.specialProjects,
  ]);
  useEffect(() => {
    const selectedData = lookUpOptions?.subjectFilter?.filter((item) =>
      contentDetailsSectionData?.subjects?.includes(item?.id)
    );
    setSelectedSubjectData(selectedData);
  }, [contentDetailsSectionData?.subjects, lookUpOptions?.subjectFilter]);
  useEffect(() => {
    const selectedVarieties = lookUpOptions?.varietyFilter?.filter((item) =>
      contentDetailsSectionData?.varieties?.includes(item?.id)
    );
    setSelectedVarities(selectedVarieties);
  }, [contentDetailsSectionData?.varieties, lookUpOptions?.varietyFilter]);
  useEffect(() => {
    const selectedSME = subjectExpert?.filter((item) =>
      contentDetailsSectionData?.subjectMatterExpert?.includes(item?.id)
    );
    setSelecteSubjectMatterExpert(selectedSME);
  }, [contentDetailsSectionData?.subjectMatterExpert, subjectExpert]);
  useEffect(() => {
    const selectedData = countryData?.filter((item) =>
      contentDetailsSectionData?.countries?.includes(item?.id)
    );
    setSelectedCountryData(selectedData);
  }, [
    contentDetailsSectionData?.countries,
    countryData,
    setCountryData,
    setSelectedSubjectData,
  ]);
  const handleSelect = (name, e) => {
    const ids = e?.map((item) => item.id);
    if (name === "sectors") {
      const countryList = getCountryList(ids, secotrByCountrylist);
      setCountryData(getDropDownOptionValues(countryList, true));
    }
    setContentDetailsSectionData((stateData) => {
      return {
        ...stateData,
        [name]: [...ids],
      };
    });
  };

  const setSpecialProjectDisabled = () => {
    let isDisabled = false;
    if (lookUpOptions?.visibility?.length) {
      const selectedOptions = lookUpOptions?.visibility?.filter((item) => {
        return item?.id === contentDetailsSectionData?.visibility;
      });

      isDisabled =
        selectedOptions?.[0]?.name === "External" ||
        selectedOptions?.[0]?.name === "Internal";
    }

    return isDisabled;
  };

  const { isDuplicate, checking } = useDuplicateTitleCheck({
    payload: {
      title: debouncedTitle,
      contentGuid: id,
    },
    url: `${BASE_URL}/curator/titles/duplicate`,
  });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        padding: "16px",
        background: useThemeRender("cardBackgroundColorLayer2"),
      }}
    >
      <Box
        className="content-details"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row", gap: "16px" }}>
          <Box sx={{ width: "338px" }}>
            <TextInput
              label="Content title"
              name="contentTitle"
              value={contentDetailsSectionData?.contentTitle}
              placeholder={"Add title"}
              maxLength={150}
              onChange={(event) => {
                setContentDetailsSectionData((stateData) => {
                  return {
                    ...stateData,
                    contentTitle: event.target.value,
                  };
                });
              }}
              data-testid="input-contentTitle"
            />
          </Box>

          {isDuplicate && (
            <Alert severity="warning" sx={{ mt: 1 }}>
              A content with this title already exists.
            </Alert>
          )}
        </Box>

        <CustomCuratorRadioGroup
          label={"Visibility"}
          name="visibility"
          required
          value={contentDetailsSectionData?.visibility}
          onChange={(event) => {
            setContentDetailsSectionData((stateData) => {
              return {
                ...stateData,
                visibility: parseInt(event.target.value),
              };
            });
          }}
          radioGroup={getDropDownOptionValues(lookUpOptions?.visibility)}
        />

        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            gap: "32px",
            "& .MuiTypography-root": {
              fontSize: "12px",
            },

            "& .MuiBox-root": {
              marginBottom: 0,
            },
          }}
        >
          <CustomSelect
            label="Special Projects"
            value={selectedSpecialProjectData}
            disabled={setSpecialProjectDisabled()}
            onChange={(e) => handleSelect("specialProjects", e)}
            options={getDropDownOptionValues(lookUpOptions?.specialProjects)}
          />
          <CustomSelect
            label="Subjects"
            value={selectedSubjectData}
            onChange={(e) => handleSelect("subjects", e)}
            options={getDropDownOptionValues(
              lookUpOptions?.subjectFilter,
              true
            )}
          />
          <CustomSelect
            label="Sectors"
            value={selectedSectorData}
            onChange={(e) => handleSelect("sectors", e)}
            options={getDropDownOptionValues(lookUpOptions?.sectorFilter)}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: isMobile ? "column" : "row",
            gap: "32px",
            "& .MuiTypography-root": {
              fontSize: "12px",
            },

            "& .MuiBox-root": {
              marginBottom: 0,
            },
          }}
        >
          <CustomSelect
            label="Countries"
            value={selectedCountryData}
            onChange={(e) => handleSelect("countries", e)}
            options={countryData}
          />

          <Box
            sx={{
              width: { xs: "300px", md: "400px" },
              marginBottom: 2,
              color: useThemeRender("textColorLayer1"),
            }}
          >
            <Typography
              variant="subtitle1"
              component="label"
              sx={{ marginBottom: 0.5 }}
            >
              Language
            </Typography>
            <Select
              value={contentDetailsSectionData?.language || ""}
              onChange={(e) => {
                const selectedLanguage = e.target.value;
                setContentDetailsSectionData((stateData) => ({
                  ...stateData,
                  language: selectedLanguage,
                }));
              }}
              sx={{
                width: "100%",
                maxWidth: "100%",
                "& .MuiSelect-select": {
                  display: "flex",
                  alignItems: "center",
                  padding: "10px 14px",
                  backgroundColor: useThemeRender("cardBackgroundColorLayer1"),
                  border: "1px solid",
                  borderColor: useThemeRender("borderColorLayer1"),
                  borderRadius: 1,
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: useThemeRender("borderColorLayer1"),
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: useThemeRender("borderColorLayer1"),
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: useThemeRender("borderColorLayer1"),
                },
                "& .MuiSelect-icon": {
                  color: useThemeRender("iconColor1"),
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    backgroundColor: useThemeRender("backgroundColorLayer3"),
                    "& .MuiMenuItem-root": {
                      color: useThemeRender("textColorLayer1"),
                      "&:hover": {
                        backgroundColor: useThemeRender(
                          "backgroundColorLayer3"
                        ),
                      },
                    },
                  },
                },
              }}
            >
              {lookUpOptions?.laguageFilter?.map((option) => (
                <MenuItem key={option.name} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </Box>
          <CustomSelect
            label="Subject matter expert"
            value={selecteSubjectMatterExpert}
            onChange={(e) => handleSelect("subjectMatterExpert", e)}
            options={subjectExpert}
            required
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: isMobile ? "column" : "row",
            gap: "32px",
            "& .MuiTypography-root": {
              fontSize: "12px",
            },

            "& .MuiBox-root": {
              marginBottom: 0,
            },
          }}
        >
          <Box
            sx={{
              width: { xs: "300px", md: "400px" },
              marginBottom: 2,
              color: useThemeRender("textColorLayer1"),
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                variant="subtitle1"
                component="label"
                sx={{ marginBottom: 1 }}
              >
                IP Ownership
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{ marginBottom: 1, fontSize: "14px", color: "#616161" }}
              >
                *Required
              </Typography>
            </Box>
            <Select
              value={contentDetailsSectionData?.ipOwnerShip || ""}
              onChange={(e) => {
                const selectedipOwnerShip = e.target.value; // Get the selected value
                setContentDetailsSectionData((stateData) => ({
                  ...stateData,
                  ipOwnerShip: selectedipOwnerShip, // Update the correct field
                }));
              }}
              sx={{
                width: "100%",
                maxWidth: "100%",
                "& .MuiSelect-select": {
                  display: "flex",
                  alignItems: "center",
                  padding: "10px 14px",
                  backgroundColor: useThemeRender("cardBackgroundColorLayer1"),
                  border: "1px solid",
                  borderColor: useThemeRender("borderColorLayer1"),
                  borderRadius: 1,
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: useThemeRender("borderColorLayer1"),
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: useThemeRender("borderColorLayer1"),
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: useThemeRender("borderColorLayer1"),
                },
                "& .MuiSelect-icon": {
                  color: useThemeRender("iconColor1"),
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    backgroundColor: useThemeRender("backgroundColorLayer3"),
                    "& .MuiMenuItem-root": {
                      color: useThemeRender("textColorLayer1"),
                      "&:hover": {
                        backgroundColor: useThemeRender(
                          "dropdownHoverColorLayer3"
                        ),
                      },
                    },
                  },
                },
              }}
            >
              {getDropDownOptionValues(lookUpOptions?.ipOwnerShipFilter)?.map(
                (option) => (
                  <MenuItem key={option.name} value={option.id}>
                    {option.name}
                  </MenuItem>
                )
              )}
            </Select>
          </Box>
          <CustomSelect
            label="Varieties"
            value={selectedVarities}
            onChange={(e) => handleSelect("varieties", e)}
            options={lookUpOptions?.varietyFilter}
            required
          />
          <Box
            sx={{
              width: { xs: "300px", md: "400px" },
              marginBottom: 2,
              color: useThemeRender("textColorLayer1"),
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                variant="subtitle1"
                component="label"
                sx={{ marginBottom: 1 }}
              >
                Flesh color
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{ marginBottom: 1, fontSize: "14px", color: "#616161" }}
              >
                *Required
              </Typography>
            </Box>
            <Select
              value={contentDetailsSectionData?.fleshColor || ""}
              onChange={(e) => {
                const selectedFlashColor = e.target.value; // Get the selected value
                setContentDetailsSectionData((stateData) => ({
                  ...stateData,
                  fleshColor: selectedFlashColor, // Update the correct field
                }));
              }}
              sx={{
                width: "100%",
                maxWidth: "100%",
                "& .MuiSelect-select": {
                  display: "flex",
                  alignItems: "center",
                  padding: "10px 14px",
                  backgroundColor: useThemeRender("cardBackgroundColorLayer1"),
                  border: "1px solid",
                  borderColor: useThemeRender("borderColorLayer1"),
                  borderRadius: 1,
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: useThemeRender("borderColorLayer1"),
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: useThemeRender("borderColorLayer1"),
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: useThemeRender("borderColorLayer1"),
                },
                "& .MuiSelect-icon": {
                  color: useThemeRender("iconColor1"),
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    backgroundColor: useThemeRender("backgroundColorLayer3"),
                    "& .MuiMenuItem-root": {
                      color: useThemeRender("textColorLayer1"),
                      "&:hover": {
                        backgroundColor: useThemeRender(
                          "dropdownHoverColorLayer3"
                        ),
                      },
                    },
                  },
                },
              }}
            >
              {getDropDownOptionValues(lookUpOptions?.flashColorFilter)?.map(
                (option) => (
                  <MenuItem key={option.name} value={option.id}>
                    {option.name}
                  </MenuItem>
                )
              )}
            </Select>
          </Box>
          
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: isMobile ? "column" : "row",
            gap: "32px",
            "& .MuiTypography-root": {
              fontSize: "12px",
            },

            "& .MuiBox-root": {
              marginBottom: 0,
            },
          }}
        >
          <Box sx={{
                width: { xs: "300px", md: "400px" },
                marginBottom: 2,
                color: useThemeRender("textColorLayer1"),
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  variant="subtitle1"
                  component="label"
                  sx={{ marginBottom: 1, fontSize: "14px", color: "#616161" }}
                >
                  Publication Date
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{ marginBottom: 1, fontSize: "12px", color: "#616161" }}
                >
                  *Required
                </Typography>
              </Box>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={
                    contentDetailsSectionData?.publicationDate
                      ? dayjs(contentDetailsSectionData.publicationDate)
                      : null
                  }
                  onChange={(newValue) => {
                    if (!newValue) {
                      setContentDetailsSectionData((stateData) => ({
                        ...stateData,
                        publicationDate: null,
                      }));
                      return;
                    }
                    // Check if newValue is already a dayjs-like object (has isValid method)
                    // This handles both real dayjs objects and test mocks
                    const dateValue = newValue.isValid ? newValue : dayjs(newValue);
                    // Check if date is valid - handle both function call and direct check
                    const isValid = typeof dateValue.isValid === 'function' 
                      ? dateValue.isValid() 
                      : dateValue.isValid;
                    if (!isValid) {
                      return;
                    }
                    setContentDetailsSectionData((stateData) => ({
                      ...stateData,
                      publicationDate: dateValue
                        .hour(dayjs().hour())
                        .minute(dayjs().minute())
                        .second(dayjs().second())
                        .millisecond(dayjs().millisecond())
                        .toISOString(),
                    }));
                  }}
                  maxDate={(pageName === CURATOR_PAGE_API_CONSTANT.artificat_history || pageName === CURATOR_PAGE_API_CONSTANT.pending_approval || pageName === CURATOR_PAGE_API_CONSTANT.yearly_review) ? dayjs() : undefined}
                  format="DD-MM-YYYY"
                  slotProps={{
                    textField: {
                      id: "publication-date-picker",
                      size: "small",
                      fullWidth: true,
                      placeholder: "DD-MM-YYYY",
                      error: !!errors?.publicationDate,
                      helperText: errors?.publicationDate?.message || "",
                      sx: {
                        "& .MuiInputBase-root": {
                          display: "flex",
                          alignItems: "center",
                          padding: "10px 14px",
                          backgroundColor: useThemeRender("cardBackgroundColorLayer1"),
                          border: "1px solid",
                          borderColor: errors?.publicationDate 
                            ? "#d32f2f" 
                            : borderColorLayer1,
                          borderRadius: 1,
                          color: useThemeRender("textColorLayer1"),
                          minHeight: "32px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: errors?.publicationDate 
                            ? "#d32f2f" 
                            : borderColorLayer1,
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: errors?.publicationDate 
                            ? "#d32f2f" 
                            : borderColorLayer1,
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: errors?.publicationDate 
                            ? "#d32f2f" 
                            : borderColorLayer1,
                        },
                        "& .MuiSvgIcon-root": {
                          color: useThemeRender("iconColor1"),
                        },
                        "& .MuiInputBase-input": {
                          padding: 0,
                          "&::placeholder": {
                            color: useThemeRender("textColorLayer1"),
                            opacity: 0.6,
                          },
                        },
                      },
                    },
                    popper: {
                      placement: "left-start",
                    },
                  }}
                />
              </LocalizationProvider>
            </Box>
          </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            flexDirection: isMobile ? "column" : "row",
            gap: "32px",
            "& .MuiTypography-root": {
              fontSize: "12px",
            },
            "& .MuiBox-root": {
              marginBottom: 0,
            },
          }}
        >
          <Box sx={{ width: { xs: "300px", md: "400px" },marginBottom: 2,
              color: useThemeRender("textColorLayer1") }}>
            <CustomCuratorRadioGroup
              label={"Content Level"}
              value={contentDetailsSectionData?.contentLevel}
              onChange={(e) => {
                setContentDetailsSectionData((stateData) => {
                  return {
                    ...stateData,
                    contentLevel: parseInt(e?.target?.value),
                  };
                });
              }}
              radioGroup={getDropDownOptionValues(lookUpOptions?.contentLevel)}
            />
          </Box>
        
        </Box>
      </Box>
    </Box>
  );
};

export default ContentDetails;
